import { IContact } from "store/types/user-management";

export const contactName = (contact: IContact): string =>
  [contact.first_name, contact.last_name].filter(Boolean).join(" ").trim();

// created_at is an ISO string; render as MM/DD/YYYY (e.g. 12/27/2025) to match the design.
export const formatAddDate = (iso: string): string => {
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? "" : date.toLocaleDateString("en-US");
};

// Single uppercase initial for the avatar — from the name, falling back to the email, else "?".
export const contactInitial = (contact: IContact): string =>
  (contactName(contact) || contact.email || "").trim().charAt(0).toUpperCase() || "?";
